import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const LensQueryGql: DocumentNode = gql`
query LensQuery($vizportalUrlId: String!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}, permissionMode: FILTER_RESULTS) {
    name
    luid
  }
}
`;
